#import "../../../../common/graphql/EntityDocumentsFields.graphql"

mutation UserProfileCreate($input: UserProfileCreateInput!) {
  userProfileCreate(input: $input) {
    clientMutationId
    userProfile {
      id
        _signinInfo{
        profileIconState
        profileIconType
        isUserAdministrator
        isProjectSupervisor
        isActivateAllowed
        isDeactivateAllowed
      }
      _activeApprovalCount
      __typename
      _urgencyLevel
      _rowTimestamp
      name
      description
      emailAccount
      isNewProjectIncluded
      _isStagedToInvite
      _isUserSignatureUpdatable
      _isUserSignatureRequired
      departmentOccupationTemplateId
      _lastUsedDate
      _activeApprovalCount
      userRankTypeId
      userRankType {
        userRank
        id
      }
      secureRowLevelId
      secureRowLevel {
        id
        securityLevel
      }
      departmentOccupationTemplate {
        name
        description
        isTemplateControlled
      }
      roleId
      role {
        name
        id
        description
      }
      userOccupationTitleId
      userOccupationTitle {
        userOccupationTitle
        userRankTypeId
      }
      departmentId
      department {
        name
      }
      departmentGroupId
      departmentGroup {
        name
      }
      communicationGroupId
      communicationGroup {
        name
      }
      tagGroupId
      tagGroup {
        name
      }
      dataAccessPolicyId
      dataAccessPolicy {
        name
      }
      accessGroupId
      accessGroup {
        name
        _isStagedApprovalRequest
        _isUpdatable
        _isDeletable
        _isApproved
        _isApprovalRevocable
      }
      userGroupId
      userGroup {
        name
      }
      invited
      _invitationStatusTypeId
      inviteStatusType {
        statusType
      }
      _statusTypeId
      statusType {
        statusType
      }
      _isUpdatable
      _isDeletable
      _isStagedApprovalRequest
      _isStagedToInvite
      _isUserApprovalTreeViewer
      _isAuthenticatedUser
      _isProfileValidated
      userApprovalGrants(
        orderBy: APPROVAL_TYPE_BY_APPROVAL_TYPE_ID__APPROVAL_TYPE_ASC
      ) {
        nodes {
          isApprover
          isRequester
          isAddingNonApproversAllowed
          isApprovalRevokingEnabled
          isApprovalTreeViewerAllowed
          isAutoApproveEnabled
          isEnMasseApprovalsEnabled
          isExtendedApprover
          isLowerTreeLevelBypassEnabled
          isSelfApproveEnabled
        }
      }
     entityDocumentsByEntityId(
      orderBy: [DOCUMENT_POSITION_ASC, _CREATED_DATE_DESC, FILE_REFERENCE_ASC]
    ) {
      nodes {
        ...EntityDocumentsFields
      }
    }
      userProfileHistoriesByEntityId {
        nodes {
          crudOperation
          pointInTimeDate
          tenantUserName
        }
      }
      notesByEntityId {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
